import React, { useEffect } from "react";
import { Modal, Form, Input, Select, Upload, Button, Spin } from "antd";
import { FaUpload, FaTrash } from "react-icons/fa";
import { Editor } from "primereact/editor";

const { Option } = Select;

const CategoryModal = ({
  isModalVisible,
  handleCancel,
  handleAddOrUpdateCategory,
  form,
  uploadedImage,
  uploadingLoading,
  handleImageUpload,
  handleRemoveImage,
  handleDescriptionChange,
  getAvailableParentCategories,
  editingCategory,
  loading,
}) => {
  useEffect(() => {
    if (editingCategory) {
      form.setFieldsValue({
        status: editingCategory.status || "Active",
      });
    } else {
      form.resetFields();
      form.setFieldsValue({ status: "Active", values: [] });
    }
  }, [editingCategory, isModalVisible]);

  return (
    <Modal
      title={editingCategory ? "Edit Collection" : "Add Collection"}
      visible={isModalVisible}
      onCancel={handleCancel}
      onOk={handleAddOrUpdateCategory}
      confirmLoading={loading}
      bodyStyle={{
        height: "500px", // Set a fixed height for the modal body
        overflow: "hidden", // Prevent the modal itself from scrolling
      }}
      style={{
        top: "50px", // Optional: Position from the top of the screen
      }}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ height: "100%", overflow: "auto" }}
      >
        <Form.Item label="Upload Image" name="image">
          <Upload
            listType="picture-card"
            showUploadList={false}
            customRequest={({ file, onSuccess }) => {
              handleImageUpload(file);
              setTimeout(() => onSuccess("ok"), 0);
            }}
          >
            <Button icon={<FaUpload />}>Upload</Button>
          </Upload>
          {uploadedImage && (
            <div className="mt-2 relative">
              <img
                src={uploadedImage}
                alt="Uploaded"
                className="w-28 h-28 object-cover rounded-md border"
              />
              <Button
                type="text"
                className="absolute top-0 right-0 text-red-500 rounded-full shadow p-1"
                icon={<FaTrash />}
                onClick={handleRemoveImage}
              />
            </div>
          )}
          {uploadingLoading && <Spin />}
        </Form.Item>

        <Form.Item
          name="name"
          label="Collection Name"
          rules={[{ required: true, message: "Please input category name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="parent_category" label="Parent Collection">
          <Select placeholder="Select a parent category">
            <Option value={null}>None</Option>
            {getAvailableParentCategories().map((category) => (
              <Option key={category._id} value={category._id}>
                {category.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Description" name="description">
          <Editor
            style={{ height: "200px" }}
            value={form.getFieldValue("description")}
            onTextChange={(e) => handleDescriptionChange(e.htmlValue)}
          />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true, message: "Please select status!" }]}
        >
          <Select>
            <Option value="Active">Active</Option>
            <Option value="Inactive">Inactive</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryModal;
